import { render, staticRenderFns } from "./-TabContainer2.vue?vue&type=template&id=6c568afa&scoped=true&"
import script from "./-TabContainer2.vue?vue&type=script&lang=js&"
export * from "./-TabContainer2.vue?vue&type=script&lang=js&"
import style0 from "./-TabContainer2.vue?vue&type=style&index=0&id=6c568afa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c568afa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OssImg: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/OssImg.vue').default,LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default})
